import { render, staticRenderFns } from "./MainCategoryIcon.vue?vue&type=template&id=707bc792&scoped=true&"
import script from "./MainCategoryIcon.vue?vue&type=script&lang=js&"
export * from "./MainCategoryIcon.vue?vue&type=script&lang=js&"
import style0 from "./MainCategoryIcon.vue?vue&type=style&index=0&id=707bc792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707bc792",
  null
  
)

export default component.exports